export default __webpack_public_path__ + "static/media/durable.0e0443fd.svg";